import { ThemeData } from "~/application/types/entities/ThemeData.type";
import { IThemeService } from "./IThemeService";
import Logo from "~/../public/signIn.png";
import Banner from "~/../public/Home.svg";

export class ThemeService implements IThemeService {
  async getThemeData(): Promise<ThemeData> {
    try {
      // TODO: Replace '/theme' with the actual CMS theme endpoint.
      const response = await Promise.resolve({
        data: {
          logoUrl: Logo,
          bannerUrl: Banner,
          colors: {
            "primary-base": "#005BC4",
            "primary-dark": "#003161",
            "header-background": "#E4E4E7",
            "nav-menu-text": "#005BC4",
            "profile-card-text": "#002E62",
            "profile-card-subtitle": "#71717A",
          },
        },
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch theme data:", error);
      throw error;
    }
  }
}
